var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyNavSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.067 5 8.5 6.567 8.5 8.5C8.5 10.433 10.067 12 12 12C13.933 12 15.5 10.433 15.5 8.5C15.5 6.567 13.933 5 12 5ZM6 8.5C6 5.18629 8.68629 2.5 12 2.5C15.3137 2.5 18 5.18629 18 8.5C18 11.8137 15.3137 14.5 12 14.5C8.68629 14.5 6 11.8137 6 8.5Z",
    fill: "#8B68DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C7.85786 15 4.5 18.3579 4.5 22.5H2C2 16.9772 6.47715 12.5 12 12.5V15Z",
    fill: "#8B68DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C16.1421 15 19.5 18.3579 19.5 22.5H22C22 16.9772 17.5228 12.5 12 12.5V15Z",
    fill: "#8B68DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNavSelected);
export default __webpack_public_path__ + "static/media/my-nav-selected.af3bf209c43340b7d8a2d552921e5439.svg";
export { ForwardRef as ReactComponent };